// @ts-nocheck
import React from "react";
import { useAuth } from "../../context/AuthContext";
import "./MyAccountModal.css"; // ensures button + layout consistency

interface SectionProps {
  onBack: () => void;
  onOpenSubmodal?: (which: "brokers" | "retailers") => void;
}

const Partners = ({ onBack, onOpenSubmodal }: SectionProps) => {
  const { user } = useAuth();

  return (
    <div className="my-account-section-content">
      <p className="my-account-intro">
        Identify your brokers and retailers to link your compliance data.
      </p>

      <ul className="my-account-links-list">
        <li>
          <strong>Brokers</strong> –{" "}
          <button
            className="my-account-link-btn"
            onClick={() => onOpenSubmodal && onOpenSubmodal("brokers")}
          >
            Manage Connections
          </button>
        </li>

        <li>
          <strong>Retailers</strong> –{" "}
          <button
            className="my-account-link-btn"
            onClick={() => onOpenSubmodal && onOpenSubmodal("retailers")}
          >
            Manage Connections
          </button>
        </li>
      </ul>

      <div className="my-account-modal-footer" style={{ justifyContent: "flex-start" }}>
        <button className="my-account-back-btn" onClick={onBack}>
          ← Back to My Account
        </button>
      </div>
    </div>
  );
};

export default Partners;
